import template from './report_survey_results.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportSurveyResultsViewModel
{
	constructor (page)
	{
		this.page = page;
		this.survey_results = ko.observableArray([]);
		this.surveys = ko.observableArray();
		this.anonymous_full_result = ko.observableArray([]);

		this.departments = ko.observableArray();
		this.segments = ko.observableArray();
		this.segment_id = ko.observable();
		this.department_id = ko.observable(0);

		this.start_date = ko.observable(moment().subtract(2, 'months').format('YYYY-MM-') + moment().subtract(2, 'months').daysInMonth());
		this.end_date = ko.observable(moment().format('YYYY-MM-') + moment().daysInMonth());

		this.survey_id = ko.observable();
		this.show_public = ko.observable(true);
		this.show_summary = ko.observable(true);
		this.emp_not_logged_in = ko.observable('normal_rg'); //TODO: make this be remembered with local storage
		this.show_normal_results = ko.observable(true);
		this.survey_summary_chart = ko.observableArray([]);

		let department_initial_update = false;

		this.show_public.subscribe((val) => {
			this.page.updateData();
			this.page.setup_chart();
		});

		this.emp_not_logged_in.subscribe((val) => {
			this.survey_id(null);
			if (val == 'normal_rg')
				this.show_normal_results(true);
			else
				this.show_normal_results(false);
		});

		this.end_date_timeout = null;
		this.start_date_timeout = null;

		this.start_date.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.start_date_timeout)
				clearTimeout(this.start_date_timeout);

			this.start_date_timeout = setTimeout(() => {
				let sd = moment(newValue, 'YYYY-MM-DD', true);
				if (!sd.isValid()) return;

				// Update end date to last day of start date month
				let month_end = moment(sd).endOf('month').format('YYYY-MM-DD');
				this.end_date(month_end);

				this.page.updateData();
			}, 500);
		});

		this.end_date.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.end_date_timeout)
				clearTimeout(this.end_date_timeout);

			// Set new timeout to wait for user to finish typing
			this.end_date_timeout = setTimeout(() => {
				let ed = moment(newValue, 'YYYY-MM-DD', true);
				if (!ed.isValid()) return;

				if (newValue.length === 10)
				{
					let sd = moment(this.start_date(), 'YYYY-MM-DD', true);
					if (sd.isValid() && ed.isBefore(sd))
					{
						Grape.alerts.alert({ type: 'error', title: tr('Invalid Date Range'), message: tr('End date cannot be before start date') });
						return;
					}
					this.page.updateData();
				}
			}, 1000);
		});

		this.department_id.subscribe( async(val) => {
			if (department_initial_update == false)
			{
				department_initial_update = true;
				return 0;
			}

			let data = {
				survey_id: this.survey_id(),
				is_public: this.show_public(),
				department_id: this.department_id()
			};

			let res = await Grape.fetches.postJSON('/surveys/report_get_survey_results', data);

			if (res)
				this.survey_results(res.survey_results);

			this.page.updateData();
			this.page.setup_chart();
		});

		this.segment_id.subscribe( async(val) => {
			this.page.updateData();
			this.page.setup_chart();
		});

		this.survey_id.subscribe( async(val) => {
			if (department_initial_update == false)
			{
				department_initial_update = true;
				return 0;
			}

			this.page.updateData();
			this.page.setup_chart();
		});

		this.show_summary.subscribe((showSummary) => {
			this.survey_summary_chart([]);

			if (showSummary == true)
				this.page.setup_chart();
		});
	}
}

class ReportSurveyResultsPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportSurveyResultsViewModel(this);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('SurveyReport'))
			return;

		document.title = tr('Survey Results');
		window.current_page_title(tr('Survey Results'));

		// get departments
		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'v_department_company',
			schema: 'savanna',
			limit: 1000,
			sortfield: 'department',
			sortorder: 'asc'
		});
		
		if (res)
		{
			for (let i = 0; i < res.records.length; i++)
				res.records[i].name = res.records[i].department + ' (' + res.records[i].company + ')';

			res.records.unshift({ 'department_id': -1, 'name': tr('All departments') });
			this.viewModel.departments(res.records);
		}

		// get segments
		let res_seg = await Grape.fetches.getJSON('/api/record', {
			table: 'segments',
			schema: 'savanna',
			limit: 1000,
			sortfield: 'name',
			sortorder: 'asc'
		});
		
		if (res_seg)
		{
			res_seg.records.unshift({ 'segment_id': -1, 'name': tr('All segments') });
			this.viewModel.segments(res_seg.records);
		}
	}

	async updateData()
	{
		if (this.viewModel.survey_id() != 0)
		{
			if (this.viewModel.show_normal_results())
			{
				let data = {
					survey_id: this.viewModel.survey_id(),
					is_public: this.viewModel.show_public(),
					department_id: this.viewModel.department_id()
				};

				let res = await Grape.fetches.postJSON('/surveys/report_get_survey_results', data);
				if (res)
					this.viewModel.survey_results(res.survey_results);
			}
			else
			{
				let data = {
					survey_id: this.viewModel.survey_id(),
					segment_id: this.viewModel.segment_id()
				};

				let res = await Grape.fetches.postJSON('/surveys/report_get_anonymous_survey_results', data);

				if (res)
					this.viewModel.survey_results(res.survey_results);

				let res2 = await Grape.fetches.postJSON('/surveys/get_filtered_emp_not_log_in_survey_report', {survey_id: this.viewModel.survey_id()});
				if (res2)
					this.viewModel.anonymous_full_result(res2.records);

			}
		}

		if (this.viewModel.start_date() != '' && this.viewModel.start_date() != undefined && this.viewModel.end_date() != '' && this.viewModel.end_date() != undefined)
			this.updateSurveyDropDown();
	}

	async updateSurveyDropDown()
	{
		let data = {
			start_date: this.viewModel.start_date(),
			end_date: this.viewModel.end_date(),
			is_public: this.viewModel.show_public()
		};

		if (!this.viewModel.show_normal_results())
			data.emp_not_log_in = false;
		else
			data.emp_not_log_in = true;

		let res = await Grape.fetches.postJSON('/surveys/get_surveys_list', data);
		if (res)
		{
			if (res.length)
				this.viewModel.surveys(res);
			else 
				this.viewModel.surveys([]);
		}
	}

	buildCircles(circle_data)
	{
		for (let a = 0; a < circle_data.length; a++)
		{
			let color = '#31859D';

			if (circle_data[a].percent <= 25)
				color = '#31859D';
			else if (circle_data[a].percent > 25 && circle_data[a].percent <= 50)
				color = '#FFC000';
			else if (circle_data[a].percent > 50 && circle_data[a].percent <= 75)
				color = '#E8740E';
			else
				color = '#FF0';

			let myCircle = Circles.create({
				id: circle_data[a].id,
				radius: 60,
				value: circle_data[a].percent,
				maxValue: 100,
				width: 10,
				text: function (value) { return value + '%'; },
				colors: [
					'#ededed', color
				],
				duration: 400,
				wrpClass: 'circles-wrp',
				textClass: 'circles-text',
				valueStrokeClass: 'circles-valueStroke',
				maxValueStrokeClass: 'circles-maxValueStroke',
				styleWrapper: true,
				styleText: true
			});
		}
	}

	download_clicked()
	{
		let survey = document.getElementById('ddlSurvey').value;
		let department = document.getElementById('ddlDepartment').value;
		let show_public = this.viewModel.show_public();

		if (survey)
		{
			let count = 0;
			if (!this.viewModel.survey_results())
			{
				Grape.alerts.alert({type: 'warning', message: tr('No responses yet'), title: tr('Warning')});
				return;
			}
			else
			{
				this.viewModel.survey_results().forEach(element => {
					if (element.survey_response)
						count = count + 1;
				});

				if (count <= 0)
				{
					Grape.alerts.alert({type: 'warning', message: tr('No responses yet'), title: tr('Warning')});
					return;
				}
			}
			window.open('/download/survey_responses/' + survey + '/'+  department +'/'+  show_public);
		}
		else 
			Grape.alerts.alert({type: 'warning', message: tr('Please choose a survey'), title: tr('Warning')});
	}

	download_anonymous_responses()
	{
		let survey = this.viewModel.survey_id();
		let segment = this.viewModel.segment_id();

		if (survey)
		{
			let count = 0;
			if (!this.viewModel.anonymous_full_result())
			{
				Grape.alerts.alert({type: 'warning', message: tr('No responses yet'), title: tr('Warning')});
				return;
			}
			else
			{
				this.viewModel.anonymous_full_result().forEach(element => {
					if (element.survey_summary)
						count = count + 1;
				});

				if (count <= 0)
				{
					Grape.alerts.alert({type: 'warning', message: tr('No responses yet'), title: tr('Warning')});
					return;
				}
			}
			window.open('/download/anonymous_survey_responses/' + survey + '/'+  segment);
		}
		else 
			Grape.alerts.alert({type: 'warning', message: tr('Please choose a survey'), title: tr('Warning')});
	}

	async setup_chart()
	{
		let item_number = 0;
		let circle_Data = new Array();
		this.viewModel.survey_summary_chart([]);

		if (this.viewModel.survey_id() != 0)
		{
			if (this.viewModel.show_normal_results())
			{
				let res = await Grape.fetches.postJSON('/surveys/get_surveys_answer_summary', {
					survey_id: this.viewModel.survey_id(), 
					department_id: this.viewModel.department_id() 
				});

				if (res)
				{
					_.forEach(res.answer_summary, (item) => {
						_.forEach(item.response, (_item) => {
							item_number++;
	
							_item.percent = Math.round(_item.count / item.answered_cnt * (1 * 100));
							_item.percent_value = (_item.count / item.answered_cnt * (1 * 100)).toFixed(2);
							_item.my_id = 'item_num_' + item_number;
	
							circle_Data.push({
								id: _item.my_id,
								percent: _item.percent
							});
						});
	
						this.viewModel.survey_summary_chart.push(item);
						this.buildCircles(circle_Data);
					});
				}
			}
			else
			{
				let res = await Grape.fetches.postJSON('/surveys/get_anonymous_surveys_answer_summary', {
					survey_id: this.viewModel.survey_id(), 
					segment_id: this.viewModel.segment_id() 
				});

				if (res)
				{
					_.forEach(res.answer_summary, (item) => {
						_.forEach(item.response, (_item) => {
							item_number++;
	
							_item.percent = Math.round(_item.count / item.answered_cnt * (1 * 100));
							_item.percent_value = (_item.count / item.answered_cnt * (1 * 100)).toFixed(2);
							_item.my_id = 'item_num_' + item_number;

							circle_Data.push({
								id: _item.my_id,
								percent: _item.percent
							});
						});

						this.viewModel.survey_summary_chart.push(item);
						this.buildCircles(circle_Data);
					});
				}
			}
		}
	}

	show_report_help()
	{
		Grape.dialog.open('SurveyResultsHelp', { 'employee_id': this.bindings.id }, {});
	}
}

export default {
	route: '[/]report/survey_results',
	page_class: ReportSurveyResultsPage,
	template: template,
	template_filename: 'translation/report_survey_results'
};
